"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecContextBuilder = void 0;
const exec_context_1 = require("./exec-context");
const logging_1 = require("../logging");
const no_scoped_logger_1 = require("../logging/no-scoped-logger");
const progress_1 = require("../progress");
const tracing_1 = require("../tracing");
class ExecContextBuilder {
    constructor() {
        this._configService = undefined;
        this._progress = progress_1.NoProgressReport.instance;
        this._traceContext = undefined;
    }
    withTraceContext(traceContext) {
        this._traceContext = traceContext;
        return this;
    }
    withProgress() {
        this._progress = new progress_1.ProgressReport();
        return this;
    }
    withLogger(config) {
        this._configService = config;
        return this;
    }
    build() {
        let traceContext = this._traceContext;
        if (!traceContext) {
            traceContext = tracing_1.TraceContext.new();
        }
        let logger = no_scoped_logger_1.NoScopedLogger.instance;
        if (this._configService) {
            logger = new logging_1.ScopedLogger(this._configService, traceContext);
        }
        return new exec_context_1.ExecContext(traceContext, logger, this._progress);
    }
}
exports.ExecContextBuilder = ExecContextBuilder;
//# sourceMappingURL=exec-context-builder.js.map